import { motion } from 'framer-motion';
import { theme } from '../theme';

/**
 * Step Indicator Component
 * Visual progress indicator showing current/completed steps
 * Mobile responsive with text hiding on small screens
 */

export const StepIndicator = ({ steps, currentStep }) => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '8px',
    marginBottom: '48px',
    flexWrap: 'wrap',
    padding: '0 16px',
  }}>
    {steps.map((step, index) => {
      const stepNumber = index + 1;
      const isActive = stepNumber === currentStep;
      const isCompleted = stepNumber < currentStep;

      return (
        <div
          key={stepNumber}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
          }}
        >
          <motion.div
            animate={{
              background: isCompleted || isActive ? theme.colors.accent : theme.colors.border,
              scale: isActive ? 1.1 : 1,
            }}
            transition={{ duration: 0.2 }}
            style={{
              width: '40px',
              height: '40px',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontFamily: theme.fonts.display,
              fontSize: '16px',
              fontWeight: '700',
              color: isCompleted || isActive ? 'white' : theme.colors.textMuted,
              flexShrink: 0,
            }}
          >
            {isCompleted ? '✓' : stepNumber}
          </motion.div>
          <span style={{
            fontFamily: theme.fonts.body,
            fontSize: '14px',
            color: isActive ? theme.colors.text : theme.colors.textMuted,
            fontWeight: isActive ? '600' : '400',
            display: 'none', // Hidden by default
            whiteSpace: 'nowrap',
          }}
          className="step-label"
          >
            {step}
          </span>
          {stepNumber < steps.length && (
            <div style={{
              width: 'clamp(20px, 5vw, 40px)',
              height: '2px',
              background: stepNumber < currentStep ? theme.colors.accent : theme.colors.border,
              marginLeft: '8px',
              flexShrink: 0,
            }} />
          )}
        </div>
      );
    })}
    <style>{`
      @media (min-width: 640px) {
        .step-label {
          display: inline !important;
        }
      }
    `}</style>
  </div>
);

export default StepIndicator;
